<p-menubar>
	<button *ngIf="addLabel != ''"pButton type="button" label="{{addLabel}}" (click)="callAddEvent()"></button>&nbsp;

	<button pButton type="button" label="Clients" [routerLink]="['/clients']"></button>&nbsp;
	<button pButton type="button" label="Products" [routerLink]="['/products/products']"></button>&nbsp;
	<button pButton type="button" label="Suppliers" [routerLink]="['/products/suppliers']"></button>&nbsp;
	<button pButton type="button" label="Orders" [routerLink]="['/products/stock']"></button>&nbsp;
</p-menubar>